import { render, staticRenderFns } from "./VideoCate.vue?vue&type=template&id=8b8c5044&scoped=true"
import script from "./VideoCate.vue?vue&type=script&lang=js"
export * from "./VideoCate.vue?vue&type=script&lang=js"
import style0 from "./VideoCate.vue?vue&type=style&index=0&id=8b8c5044&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8c5044",
  null
  
)

export default component.exports